var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "#B1924C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5312 0.357666V0.34375L17.5234 0.351562L0 13.9062L2.38254 17.0182L17.4995 5.41504L32.562 17.0535L34.9532 13.8746L30.0312 10.0559V3.70312H24.9688V6.12817L17.5312 0.357666ZM5.48438 17.6562L17.4844 7.90625L29.4844 17.6562V29.6562H20.4844V20.6562H14.4844V29.6562H5.48438V17.6562Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ed086471b483eaf2ccabdfb9a5927eaf.svg";
export { ForwardRef as ReactComponent };